// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ commons
import { formatText } from 'core/i18n';
// @ utilities
//const classNames = require('classnames');
// @ components
const { OtpViewAC } = require('components/changeDataAC/signaturePattern/OtpViewAC');
const { PassCode } = require('components/changeDataAC/signaturePattern/passCode');
// @ actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');

class SignaturePattern extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            closeComponent: false,
            showPassCode: false,
            positions: '',
            keySize: '',
            showComponentPassCode: false,
            showComponentOTP: false,
            allVerificationDone: false,
            buttonConfirm: true,
            errorRequest: false,
        };

        this.callOTP = this.callOTP.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleOnCancel = this.handleOnCancel.bind(this);
        this.verificationComplete = this.verificationComplete.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { actions, operationType, userProfile, formActions } = this.props;
        const accessToken = userProfile.accessToken;
        for (let i = 0; i <= 8; i++) {
            formActions.reset('userProfile.position_' + i);
        }
        formActions.reset('userProfile.otpCodeAC');
        actions.init(operationType, accessToken, (res, data) => {
            if (res) {
                this.setState({
                    allVerificationDone: data.allVerificationDone,
                });
                if (data.stepPositionsRequired) {
                    this.setState({
                        showComponentPassCode: true,
                        positions: data.positions,
                        keySize: data.signatureLength,
                    });
                }
                if (data.stepOtpRequired) {
                    this.setState({
                        showComponentOTP: true,
                    });
                }
            } else {
                this.setState({
                    errorRequest: true,
                });
            }
        });
    }

    callOTP() {
        this.setState({
            showComponentOTP: true,
        });
    }
    onHandleReloadOTPCode = () => {
        const { actions, operationType, userProfile, formActions } = this.props;
        const accessToken = userProfile.accessToken;
        this.setState({
            showComponentOTP: false,
            showComponentPassCode: false,
        });
        for (let i = 0; i <= 8; i++) {
            formActions.reset('userProfile.position_' + i);
        }
        formActions.change('userProfile.otpCodeAC', '');
        actions.init(operationType, accessToken, (res, data) => {
            if (res) {
                this.setState({
                    allVerificationDone: data.allVerificationDone,
                });
                if (data.stepPositionsRequired) {
                    this.setState({
                        showComponentPassCode: true,
                        positions: data.positions,
                        keySize: data.signatureLength,
                    });
                }
                if (data.stepOtpRequired) {
                    this.setState({
                        showComponentOTP: true,
                    });
                }
            } else {
                this.setState({
                    errorRequest: true,
                });
            }
        });
    };

    verificationComplete() {
        this.setState({
            allVerificationDone: true,
            buttonConfirm: false,
        });
    }

    handleConfirm() {
        const { actions, operationType, data, userProfile, formActions } = this.props;
        const accessToken = userProfile.accessToken;
        if (this.state.allVerificationDone) {
            if (operationType == 'modify_email') {
                actions.updateEmail(data['email'], accessToken, res => {
                    if (res) {
                        this.props.onSuccess();
                    }
                });
            }
            if (operationType == 'modify_telephone') {
                actions.updateTelephone(data['telephone'], accessToken, res => {
                    if (res) {
                        this.props.onSuccess();
                    }
                });
            }
            if (operationType == 'modify_telephone_with_email') {
                actions.updateTelephoneByEmail(data['telephone'], accessToken, res => {
                    if (res) {
                        this.props.onSuccess();
                    }
                });
            }
            if (operationType == 'modify_address') {
                actions.updateAddress(data['address'], accessToken, res => {
                    if (res) {
                        this.props.onSuccess();
                    }
                });
            }
            for (let i = 0; i <= 8; i++) {
                formActions.reset('userProfile.position_' + i);
            }
            formActions.reset('userProfile.otpCodeAC');
        }
    }

    handleOnCancel() {
        const { formActions } = this.props;
        this.props.onCancel();
        for (let i = 0; i <= 8; i++) {
            formActions.reset('userProfile.position_' + i);
        }
        formActions.reset('userProfile.otpCodeAC');
        formActions.reset('userProfile.address_2');
        formActions.reset('userProfile.typeOfRoad_2');
        formActions.reset('userProfile.addressNumber_2');
        formActions.reset('userProfile.nameOfRoad_2');
        formActions.reset('userProfile.postalCode_2');
        formActions.reset('userProfile.province_2');
        formActions.change('userProfile.address_2Filled', false);
    }

    render() {
        const requestOK = (
            <div className="joint-holder__otp-hc">
                <div className="inner-form prospects-gutter prospects-separator otp-block">
                    {this.state.showComponentPassCode ? (
                        <PassCode
                            showOTP={this.callOTP}
                            operationType={this.props.operationType}
                            positions={this.state.positions}
                            keySize={this.state.keySize}
                        />
                    ) : null}
                    {this.state.showComponentOTP ? (
                        <OtpViewAC
                            reloadOTPCode={this.onHandleReloadOTPCode}
                            complete={this.verificationComplete}
                            operationType={this.props.operationType}
                        />
                    ) : null}
                    <hr />
                    <div className="inner-form__footer--buttons">
                        <button
                            onClick={this.handleOnCancel}
                            type="button"
                            className="form__button form__button-negativeB"
                        >
                            {formatText('button-cancel')}
                        </button>
                        <button
                            onClick={this.handleConfirm}
                            disabled={this.state.buttonConfirm}
                            className="form__button form__button-primaryB"
                        >
                            {formatText('button-confirm')}
                        </button>
                    </div>
                </div>
            </div>
        );
        return <div>{this.state.errorRequest ? null : requestOK}</div>;
    }
}

module.exports.SignaturePattern = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(SignaturePattern);
